<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox hide" v-if="is_hearing==1">
        <div class="btnBox">
          <button class="btn btn-search">单题</button>
          <button class="btn btn-reset">多题</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>题库列表</p>
        </div>
        <div class="organiza-list">
          <div class="titleList" :class="is_hearing==0?'list':''">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList" :class="is_hearing==0?'list':''">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.que_num">{{item.que_num}}</p>
              <p :title="item.exer_name">{{item.exer_name}}</p>
              <p :title="item.label" v-if="is_hearing==1">
                <span>{{item.label}}</span>
              </p>
              <p class="topic_title" :title="item.topic_title">{{item.topic_title}}</p>
              <p :title="item.answer">{{item.answer}}</p>
              <p :title="item.content" v-if="item.video">
                <span>{{item.content}}</span>
              </p>
              <div class="topic_content" v-html="item.content" v-else></div>
              <p style="color:#FF7543;">
                  <span @click="lookAudio(item,index)" v-if="is_hearing==1">查看音频</span>
                  <span @click="editShow(item)">编辑</span>
                  <span @click="removeSub(item)">删除</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">编辑题目</p>
        <form>
          <div class="write-txt">
            <p>题号：</p>
            <input type="text" v-model="addObj.que_num">
          </div>
          <div class="write-txt">
            <p>大标题：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>题干标题：</p>
            <input type="text" v-model="addObj.label">
          </div>
          <div class="write-txt">
            <p>题干：</p>
            <input type="text" v-model="addObj.topic_title">
          </div>
          <div class="write-txt">
            <p>选项A：</p>
            <input type="text" v-model="addObj.option_A">
          </div>
          <div class="write-txt">
            <p>选项B：</p>
            <input type="text" v-model="addObj.option_B">
          </div>
          <div class="write-txt">
            <p>选项C：</p>
            <input type="text" v-model="addObj.option_C">
          </div>
          <div class="write-txt">
            <p>选项D：</p>
            <input type="text" v-model="addObj.option_D">
          </div>
          <div class="write-txt ">
            <p>{{is_hearing==1?'听力文本':'素材'}}：</p>
            <myEditor v-if="is_hearing==0" class="write-content" @input="sourceInput" @imgUpload="imgUpload" :value="addObj.content" :index="1" @click="sourceClick(index)"/>
            <textarea v-else v-model="addObj.content"></textarea>
          </div>
          <div class="write-txt">
            <p>解析：</p>
            <input type="text" v-model="addObj.analysis">
          </div>
          <div class="write-txt">
            <p>答案：</p>
            <input type="text" v-model="addObj.answer">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

    <!-- 音频 -->
    <div class="msgBox tipsBox uploadBox" v-if="audioType">
      <div class="contv" style="height: auto;">
        <p class="title">请上传音频</p>
        <form>
          <div class="form-txt">
              <div class="txt">
                <div class="upload">
                  <el-upload
                    :action="'https://upload.qiniup.com'"
                    :data="uploadObj" 
                    list-type="picture-card"
                    :before-upload="beforeUploadPadImg"
                    :on-success="handleSuccessPadImg"
                    :on-progress="handleProgressImg"
                    :on-remove="handleRemoveImg">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <audio :src="'https://pic.bi-rong.com/'+uploadUrl" controls v-if="uploadUrl"></audio>
                </div>
              </div>
            </div>
        </form>
        <div class="btnBox">
          <!-- <button class="btn btn-sub" @click="">确认</button> -->
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>

  
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import myEditor from './../components/comment/wangeditor.vue'
import { getExerTopicList,editExerTopic,delExerTopic,getUploadToken,editExerTopicVideo } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'序号'},
        {id:6,title:'题号'},
        {id:3,title:'题干'},
        {id:4,title:'答案'},
        {id:2,title:'素材'},
        {id:5,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        model_id:''
      },
      addObj:{
        small_topic_id:'',
        model_id:'',
        que_num:'',
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      statusList:[
        {id:9,title:'全部'},
        {id:1,title:'开启'},
        {id:0,title:'未开启'},
      ],
      uploadUrl:'',
      dialogVisible:false,
      directionsType:false,
      imgUrl:'',
      audioUrl:'',
      audioType:false,
      url:'',
      is_hearing:0,
      audioIndex:0,
      uploadObj:{
        token:'',
        key:'',
      },
      big_topic_id:''
    };
  },
  components: {
    navBox,
    myHeader,
    myEditor
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.url = this.$refs.navBox.url;
    this.obj.model_id = this.$route.query.model_id;
    this.getToken();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    // 取消
    closeSub(){
      var that = this;
      this.directionsType = false;
      this.audioType = false;
      this.showType = '';
      this.addObj={
        small_topic_id:'',
        que_num:'',
      }
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      editExerTopic(that.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      var that = this;
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.dataList = [];
      this.addObj={
        small_topic_id:'',
        que_num:'',
      };
      this.getList();
    },

    getList(){
      var that = this;
      getExerTopicList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
          that.is_hearing = data.data.is_video;
          if(that.is_hearing == 1){
            that.titleList=[
              {id:1,title:'序号'},
              {id:6,title:'题号'},
              {id:3,title:'大标题'},
              {id:4,title:'题干标题'},
              {id:7,title:'题干'},
              {id:2,title:'答案'},
              {id:8,title:'听力文本'},
              {id:5,title:'操作'},
            ]
          } else {
            that.titleList=[
              {id:1,title:'序号'},
              {id:6,title:'题号'},
              {id:3,title:'大标题'},
              {id:7,title:'题干'},
              {id:2,title:'答案'},
              {id:8,title:'素材'},
              {id:5,title:'操作'},
            ]
          }
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
      this.addObj.name = '';
    },

    editShow(e){
      this.showType = 'edit';
      this.addObj.small_topic_id = e.small_topic_id;
      this.addObj.que_num = e.que_num;
      this.addObj.topic_title = e.topic_title;
      this.addObj.answer = e.answer;
      this.addObj.option_A = e.option_A;
      this.addObj.option_B = e.option_B;
      this.addObj.option_C = e.option_C;
      this.addObj.option_D = e.option_D;
      this.addObj.big_topic_id = e.big_topic_id;
      this.addObj.eid = e.eid;
      this.addObj.label = e.label;  
      this.addObj.name = e.exer_name;  
      this.addObj.analysis = e.analysis;  
      if(e.content){
        this.addObj.content = e.content;
      };
      if(e.prompt){
        this.addObj.prompt = e.prompt;
      } 
      console.log(this.addObj,'==addObj==')
    },

    switchChange(e){
      var that = this;
      var obj = {
        mtid:e.mtid,
        status:e.publish_status==false?0:1,
      };
      publishMockTest(obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('发布状态修改成功！');
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },

    topicSub(e){
      var that = this;
      console.log(e.mtid)
      that.$router.push('/pack?id='+e.mtid);
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.uploadUrl = '';
    },

    handleRemove(file, fileList) {
      console.log(file, fileList,'remove');
      this.uploadUrl = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(response, file, fileList){
      this.uploadUrl = response.data.src;
      this.dataList[this.audioIndex].video = response.data.src;
      console.log(this.uploadUrl,'==this.uploadUrl==')
    },

    getToken(){
      getUploadToken(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          this.uploadObj.token = data.data.token
        }
      })
    },

   
    beforeUploadPadImg(file){
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },
    handleSuccessPadImg(response, file, fileList){
    console.log(response,'==response==')
    var that = this;
      this.uploadUrl = response.key;
      this.dataList[this.audioIndex].video = response.key;
      this.loading = false;
      this.uploadObj.key = '';
      this.imgType = false;
      editExerTopicVideo({big_topic_id:this.big_topic_id,video:response.key},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.audioType = false;
          that.resetSub();
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },
    
    handleSuccess(response, file, fileList){
      console.log(response)
      this.uploadUrl = response.data.src;
      this.loading = false;
    },
    handleProgressImg(event, file, fileList) {
      this.loadTxt = '已上传' + file.percentage.toFixed(0) + '%';
    },
   
    handleRemoveImg(){
      this.uploadUrl = '';
      this.addObj.img = '';
    },

    lookImg(){
      this.directionsType = true;
      this.uploadUrl = this.imgUrl;
    },

    lookAudio(e,i){
      this.audioType = true;
      this.audioIndex = i;
      this.uploadUrl = e.video;
      this.big_topic_id = e.big_topic_id;
    },

    removeSub(e){
      var that = this;
      this.$confirm('此操作将确认删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // });
        delExerTopic({small_topic_id:e.small_topic_id},this.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('成功!');
            that.resetSub();
          } else {
            that.$message(data.msg);
            e.publish_status = !e.publish_status;
          }
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });          
      });
      
    },


    sourceClick(i){
      console.log(i,'==i==')
    },

    sourceInput(value,index) {
      // this.addObj.topics[index].content = value;
      console.log('value',value)
      this.addObj.content = value;
    },

    imgUpload(type){
      console.log(type,'==type==')
    },

    
  },
};
</script>
<style scoped>
.dataList .listItem .topic_content,
.dataList .listItem .topic_title,
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 8 );
  word-break: break-word;
}

.dataList .listItem p span{
  display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
  -webkit-box-orient: vertical; /* 垂直排列 */
  -webkit-line-clamp: 2; /* 限制显示两行 */
  overflow: hidden; /* 隐藏超出范围的内容 */
  text-overflow: ellipsis; /* 使用省略号 */
}

.dataList.list .listItem .topic_content,
.dataList.list .listItem p, 
.titleList.list  p{
  width: calc( 100% / 7 );
}

.dataList .listItem .topic_content {
  display: inline-block;
  padding: 21px 30px;
  word-break: break-word;
  font-size: 14px;
}

.dataList .listItem .topic_content >>> p{
  padding: 0!important;
  width: 100%;
}

.dataList .listItem .topic_content >>> p img{
  width: 100%;
}

.tipsBox form .write-txt textarea,
.tipsBox form .write-txt input{
  width: 500px;
}
.tipsBox form .write-txt textarea{
  font-size: 15px;
  color: #3D3D3D;
  background-color: #F4F5F8;
  border-radius: 10px;
  height: 200px;
  box-sizing: border-box;
  padding: 10px 20px;
}

.tipsBox.uploadBox .txt{
  height: auto;
  line-height: auto;
}

.tipsBox.uploadBox .txt .img{
  width: 200px;
  display: block;
  margin: 0 auto;
}

.tipsBox.uploadBox .txt .img img{
  width: 100%;
}

.tipsBox form .write-content {
  text-align: left;
  display: inline-block;
  vertical-align: top;
  width: 500px;
}

.tipsBox form .write-content >>> .editor-cont{
  height: 200px!important;
  width: 100%;
}

.tipsBox form .write-content >>> p{
  display: block;
  width: auto;
  margin: 0;
  line-height: auto;
  height: auto;
  word-break: break-word;
}

.tipsBox form .write-content >>> .w-e-text-container,
.tipsBox form .write-content >>> .w-e-text-container .w-e-scroll,
.tipsBox form .write-content >>> .w-e-text-container{
  width: 100%;
}

.tipsBox .contv{
  height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/exam/exercisesTopic.vue